module.exports = __webpack_public_path__ + "img/lesson-dummy.134867c5.jpg";